import { useMemo } from "react";

export const useEditorMainPageContextValue = (contextValue) => {
  return useMemo(() => contextValue, [contextValue]);
};
